import ExitToAppIcon from '@mui/icons-material/ExitToApp'
import Button from '@mui/material/Button'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import { FC, MouseEvent } from 'react'
import { semanticColors } from 'src/features/theme/semanticColors'

// 型定義
type MenuItemType = {
  label: string
  onClick: () => void
}

type RecordsEditMenuProps = {
  anchorEl: HTMLElement | null
  isOpen: boolean
  menuItems: MenuItemType[]
  onMenuClick: (event: MouseEvent<HTMLButtonElement>) => void
  onMenuClose: () => void
}

const menuPaperSx = {
  '& .MuiPaper-root': {
    width: '192px',
    marginTop: '5px',
  },
} as const

const menuItemSx = {
  fontFamily: 'Noto Sans JP',
  fontWeight: 700,
  fontStyle: 'Bold',
  fontSize: '16px',
  justifyContent: 'flex-start',
  color: semanticColors.colorTextBase,
  width: '100%',
} as const

const RecordsEditMenu: FC<RecordsEditMenuProps> = ({
  anchorEl,
  isOpen,
  menuItems,
  onMenuClick,
  onMenuClose,
}) => {
  return (
    <>
      <Button
        color="secondary"
        size="medium"
        variant="contained"
        startIcon={<ExitToAppIcon />}
        onClick={onMenuClick}
        aria-haspopup="true"
        aria-expanded={isOpen ? 'true' : undefined}
      >
        データを更新する
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={isOpen}
        onClose={onMenuClose}
        sx={menuPaperSx}
      >
        {menuItems.map((item: MenuItemType) => (
          <MenuItem key={item.label} onClick={item.onClick} sx={menuItemSx}>
            {item.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}

export default RecordsEditMenu
